import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import { routes_config } from '../../shared/routes';
import { useState, useEffect } from 'react';
import { apiRequests } from '../../shared/api/apiRequests.js';

export const Breadcrumbs = () => {
  const location = useLocation();
  const [productName, setProductName] = useState('');
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  // Не показываем глобальные крошки на страницах модификаторов (список, создание, редактирование)
  const productsIndex = pathSegments.indexOf('products');
  
  // Проверяем наличие модификаторов в пути
  const isModifiersPage = pathSegments.includes('products') && 
                        productsIndex !== -1 && 
                        pathSegments.length > productsIndex + 1 && 
                        ((pathSegments.length > productsIndex + 2 && 
                          pathSegments[productsIndex + 2] === 'modifiers') || 
                         (pathSegments.length > productsIndex + 3 && 
                          pathSegments[productsIndex + 2] === 'modifiers'));
  
  if (isModifiersPage) return null;
  
  // Проверяем, содержит ли путь ID продукта
  const isProductPage = pathSegments.includes('products') && pathSegments.length > 2;
  const productId = isProductPage ? pathSegments[pathSegments.indexOf('products') + 1] : null;
  
  // Если находимся на странице продукта, загружаем его название
  useEffect(() => {
    if (productId && !isNaN(productId)) {
      apiRequests.products.getById(productId)
        .then((product) => {
          if (product && product.title) {
            setProductName(product.title);
          }
        })
        .catch(error => {
          console.error('Ошибка при получении данных о продукте:', error);
        });
    }
  }, [productId]);

  const findRoutes = (config, pathSegments) => {
    const breadcrumbs = [];
    let currentConfig = config;
    for (const segment of pathSegments) {
      let matchedRoute;
      if (currentConfig[0] && currentConfig[0].children) {
        if (segment.startsWith(':')) {
          matchedRoute = currentConfig[0].children.find((route) => route.path.includes(':'));
        } else {
          matchedRoute = currentConfig[0].children.find((route) => route.path === segment);
        }
      } else {
        if (segment.startsWith(':')) {
          matchedRoute = currentConfig.children.find((route) => route.path.includes(':'));
        } else {
          matchedRoute = currentConfig.find((route) => route.path === segment);
        }
      }
      if (matchedRoute) {
        breadcrumbs.push(matchedRoute);
        currentConfig = matchedRoute.children || [];
      }
    }
    return breadcrumbs;
  };

  const breadcrumbRoutes = findRoutes(routes_config, pathSegments);

  return (
    <Breadcrumb>
      <Breadcrumb.Item key={'/'} linkAs={Link} linkProps={{ to: '/' }}>
        Главная
      </Breadcrumb.Item>
      {breadcrumbRoutes.map((route, index) => {
        const to = `/${pathSegments.slice(0, index + 1).join('/')}`;
        
        // Проверяем, является ли текущий маршрут страницей продукта
        const isProductRoute = pathSegments[index] === 'products' && 
                             index < pathSegments.length - 1 && 
                             !isNaN(pathSegments[index + 1]);
        
        // Проверяем, является ли текущий элемент ID продукта
        const isProductIdRoute = index > 0 && 
                               pathSegments[index - 1] === 'products' && 
                               !isNaN(pathSegments[index]);
        
        // Определяем текст для хлебной крошки
        let breadcrumbText = route.nameItem;
        
        // Если это ID продукта и у нас есть название продукта, используем его
        if (isProductIdRoute && productName) {
          breadcrumbText = productName;
        }
        
        return (
          <Breadcrumb.Item key={to} linkAs={Link} linkProps={{ to }}>
            {breadcrumbText}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};
